<template>
  <div>
    <ApprovalDocument
      :board="board"
      :value="form.body"

      @close="onClickClose"
      @delete="onClickDelete"
      @recall="onClickRecall"
      @print="onClickPrint"
      @tempsave="onClickTempsave"
      @retempsave="onClickReTempsave"
      @upload="onClickUpload"
      @ok="onClickOk"
      @no="onClickNo"
    >
      <template #header="props">
        <p class="h4 flex" style="align-items: center">
          전기설비 점검결과 기록표
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.year" :readonly="true"/>년
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.month" :readonly="board.readonly"/>월
        </p>
      </template>

      <template #body="props">
        <div id="print">
          <!-- 기본정보 -->
          <m-group label="기본정보" :division="3">
            <m-form label="사업장명" :value="form.body.baseInfo.project_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.project_name"/>
            </m-form>
            <m-form label="소속" :value="form.body.baseInfo.com_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.com_name"/>
            </m-form>
            <m-form label="점검일자" :value="form.body.baseInfo.check_date" >
              <date-selector class="w-full" v-model="form.body.baseInfo.check_date" />
            </m-form>
            <m-form label="관리감독자" :value="form.body.baseInfo.supervisor" >
              <vs-input class="w-full" v-model="form.body.baseInfo.supervisor"/>
            </m-form>
            <m-form label="점검담당자" :value="form.body.baseInfo.manager" >
              <vs-input class="w-full" v-model="form.body.baseInfo.manager"/>
            </m-form>
          </m-group>
          <m-form class="mb-4" label="점검대상" :value="selectedWorkTypeList">
            <div class="w-full flex flex-wrap" >
              <span
                v-for="(workType, index) in form.body.baseInfo.workTypeTitleList"
                :key="`work_type_list_${index}`">
                <vs-checkbox v-model="form.body.baseInfo.workType[index]"
                             class="mr-4"
                >{{ workType }}</vs-checkbox>
              </span>
            </div>
          </m-form>

          <!-- 기본사항 -->
          <m-group style="margin-top: 2rem;" label="기본사항" :division="3">
            <m-form label="수전전압/용량"
                    :value="`${form.body.baseInfo2.수전전압용량.v}V / ${form.body.baseInfo2.수전전압용량.kw}kW`" >
              <vs-row>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.수전전압용량.v"/>
                  <span class="ml-2 mr-4">V</span>
                </vs-col>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.수전전압용량.kw"/>
                  <span class="ml-2 mr-4">kW</span>
                </vs-col>
              </vs-row>
            </m-form>
            <m-form label="발전전압/용량"
                    :value="`${form.body.baseInfo2.발전전압용량.v}V / ${form.body.baseInfo2.발전전압용량.kw}kW`" >
              <vs-row>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.발전전압용량.v"/>
                  <span class="ml-2 mr-4">V</span>
                </vs-col>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.발전전압용량.kw"/>
                  <span class="ml-2 mr-4">kW</span>
                </vs-col>
              </vs-row>
            </m-form>
            <m-form label="태양광"
                    :value="`${form.body.baseInfo2.태양광.v}V / ${form.body.baseInfo2.태양광.kw}kW`" >
              <vs-row>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.태양광.v"/>
                  <span class="ml-2 mr-4">V</span>
                </vs-col>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.태양광.kw"/>
                  <span class="ml-2 mr-4">kW</span>
                </vs-col>
              </vs-row>
            </m-form>
            <m-form label="계약용량"
                    :value="`${form.body.baseInfo2.계약용량}kW`" >
              <vs-row>
                <vs-col class="w-full grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.계약용량"/>
                  <span class="ml-2 mr-4">kW</span>
                </vs-col>
              </vs-row>
            </m-form>
            <m-form label="점검종별"
                    :value="`${form.body.baseInfo2.점검종별.value} ${form.body.baseInfo2.점검종별.etc ? `(${form.body.baseInfo2.점검종별.etc})` : ''}`" >
              <vs-row>
                <vs-col class="w-1/2 grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-select class="w-full" autocomplete v-model="form.body.baseInfo2.점검종별.value">
                    <vs-select-item
                      v-for="(item, index) in 점검종별List" :key="index"
                      :text="item.text"
                      :value="item.value"/>
                  </vs-select>
                  <span class="ml-2 mr-4" style="visibility: hidden">V</span>
                </vs-col>
                <vs-col class="w-1/2">
                  <vs-input class="w-full" v-model="form.body.baseInfo2.점검종별.etc"/>
                </vs-col>
              </vs-row>
            </m-form>
            <m-form label="점검횟수"
                    :value="`${form.body.baseInfo2.점검횟수}`" >
              <vs-row>
                <vs-col class="w-full grid" style="grid-template-columns: 1fr auto; align-items: center;">
                  <vs-select class="w-full" autocomplete v-model="form.body.baseInfo2.점검횟수">
                    <vs-select-item
                      v-for="index in 5" :key="`점검횟수_${index}`"
                      :text="index"
                      :value="index"/>
                  </vs-select>
                </vs-col>
              </vs-row>
            </m-form>
          </m-group>

          <!-- 점검항목 및 점검결과 -->
          <m-title style="margin-top: 2rem;" label="점검항목 및 점검결과" />
          <m-check-table
            title="구분"
            :menus="menuA"
            menu-width="128px"
          >
            <template v-slot:header>
              <check-table-header :division="2" title="해당설비"/>
            </template>
            <template v-slot:default="{ menu }">
              <div style="display: grid; grid-template-columns: repeat(2, 1fr)">
                <check-table-body-item
                  v-for="work in form.body.check.checkListA[menu]"
                  :key="work.text"
                  :dataTypes="menuResults"
                  :value="work"
                  :is-print="isPrint"
                />
              </div>
            </template>
          </m-check-table>

          <!-- 점검결과 -->
          <m-title style="margin-top: 2rem;" label="점검결과" />
          <vs-row class="border-y"> <!-- header -->
            <vs-col class="w-4/12" v-for="i in 3" :key="`test_${i}`">
              <vs-row :class="{'border-left': i > 1}" style="display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; background-color: rgb(249, 249, 249); text-align: center;" >
                <vs-col>
                  <vs-row class="border-bottom" style="min-height: 50px; display: flex; align-items: center; justify-content: center;"><span>구분</span></vs-row>
                  <vs-row style="min-height: 50px; display: grid; grid-template-columns: 1fr 60px;">
                    <vs-col style="display: flex; align-items: center; justify-content: center;"><span>측정개소</span></vs-col>
                    <vs-col class="border-left" style="display: flex; align-items: center; justify-content: center;"><span>상별</span></vs-col>
                  </vs-row>
                </vs-col>
                <vs-col class="border-left" style="display: flex; align-items: center; justify-content: center;"><span>전압(V)</span></vs-col>
                <vs-col class="border-left" style="display: flex; align-items: center; justify-content: center;"><span>전류(A)</span></vs-col>
                <vs-col class="border-left" style="display: flex; align-items: center; justify-content: center;"><span>온도(°C)</span></vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <vs-row class="border-bottom"> <!-- body -->
            <vs-col class="w-4/12" v-for="(result, index) in form.body.check.result" :key="`form_body_check_result_${index}`">
              <vs-row class="h-full" :class="{'border-left': index > 1}" style="display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; text-align: center;" >
                <vs-col>
                  <vs-row class="h-full" style="min-height: 50px; display: grid; grid-template-columns: 1fr 60px;">
                    <vs-col class="p-1">
                      <span v-if="isPrint">{{ result.측정개소 }}}</span>
                      <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="8" v-model="result.측정개소" />
                    </vs-col>
                    <vs-col class="border-left">
                      <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;"><span>A-B</span></div>
                      <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;"><span>B-C</span></div>
                      <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;"><span>C-A</span></div>
                      <div class="p-1 " style="min-height: 50px; display: flex; justify-content: center; align-items: center;"><span>N-</span></div>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col class="border-left">
                  <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['A-B'].전압 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['A-B'].전압"/></div>
                  <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['B-C'].전압 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['B-C'].전압"/></div>
                  <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['C-A'].전압 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['C-A'].전압"/></div>
                  <div class="p-1" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['N-'].전압 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['N-'].전압"/></div>
                </vs-col>
                <vs-col class="border-left">
                  <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['A-B'].전류 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['A-B'].전류"/></div>
                  <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['B-C'].전류 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['B-C'].전류"/></div>
                  <div class="p-1 border-bottom" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['C-A'].전류 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['C-A'].전류"/></div>
                  <div class="p-1" style="min-height: 50px; display: flex; justify-content: center; align-items: center;">
                    <span v-if="isPrint">{{ result.상별['N-'].전류 }}</span>
                    <vs-input v-else class="w-full" v-model="result.상별['N-'].전류"/></div>
                </vs-col>
                <vs-col class="border-left p-1">
                  <span v-if="isPrint">{{ result.온도 }}</span>
                  <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="8" v-model="result.온도"/></vs-col>
              </vs-row>
            </vs-col>
          </vs-row>

          <!-- 안전교육 및 종합의견 -->
          <m-title style="margin-top: 2rem;" label="안전교육 및 종합의견" />
          <vs-row>
            <vs-col class="w-1/2">
              <div class="border-y" style="
              height: 50px; background-color: #f9f9f9;
              display: flex; justify-content: center;
              align-items: center; font-size: 14px; font-weight: 500;">
                <span>전기안전교육</span>
              </div>
              <div class="p-4">
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">1.</span>
                  <div style="font-size: 14px; font-weight: 400;">물기에 젖은 손발일 경우 전기기계, 기구류의 조작을 금하십시오.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">2.</span>
                  <div style="font-size: 14px; font-weight: 400;">각 기기의 접지선 탈락 여부를 수시로 확인하여 감전사고를 예방하십시오.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">3.</span>
                  <div style="font-size: 14px; font-weight: 400;">전기담당자 외 임의로 전기기기 조작이나 보수를 금하십시오.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">4.</span>
                  <div style="font-size: 14px; font-weight: 400;">금속재 외함을 갖는 전기기계, 기구 등에는 반드시 누전차단기로 보호하여 주십시오.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">5.</span>
                  <div style="font-size: 14px; font-weight: 400;">일과 종료 후 사용하지 않는 전원 차단기는 개방하십시오.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">6.</span>
                  <div style="font-size: 14px; font-weight: 400;">수·변전실 출입문에 잠금장치를 하고 전기 담당자 이외 출입을 금하도록 하십시오.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;"><span class="mr-2">7.</span>
                  <div style="font-size: 14px; font-weight: 400;">전기설비의 개·보수 작업은 반드시 정전상태에서 시행하시기 바랍니다.</div>
                </div>

              </div>
            </vs-col>
            <vs-col class="w-1/2 border-left">
              <div class="border-y " style="
              height: 50px; background-color: #f9f9f9;
              display: flex; justify-content: center;
              align-items: center; font-size: 14px; font-weight: 500;">
                <span>종합의견</span>
              </div>
              <div class="p-4">
                <span v-if="isPrint">{{ form.body.check.next }}</span>
                <vs-textarea v-else class="m-0" :rows="10" v-model="form.body.check.next"></vs-textarea>
              </div>
            </vs-col>
            <vs-col class="p-4 border-y" style="background-color: #f9f9f9; display: grid; grid-template-columns: auto 1fr;">
              <span>※ 부적합 전기설비를 방치하면 감전, 전기화재 및 정전, 전력손실 등의 원인이 될 수 있으니 조속히 개수하시기 바랍니다.</span>
            </vs-col>
          </vs-row>

          <!-- 첨부파일 -->
          <file-upload-module class="w-full" style="margin-top: 2rem;" v-model="fileList"></file-upload-module>
        </div>
      </template>

    </ApprovalDocument>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import Template from '@/views/admin/approval/Template'
import SafetyAccidentBasicData from '@/views/content/safety/SafetyAccidentBasicData'
import SafetyCheckBasicInfo from '@/views/write/safetycheck/components/SafetyCheckBasicInfo'
import MGroup from '@/components/base-ui/MGroup'
import MForm from '@/components/base-ui/MForm'
import MTitle from '@/components/base-ui/MTitle'
import MCheckTable from '@/components/base-ui/MCheckTable'
import CheckTableHeader from '@/views/write/safetycheck/electrical_equipment_check/component/CheckTableHeader'
import CheckTableBodyItem from '@/views/write/safetycheck/electrical_equipment_check/component/CheckTableBodyItem'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DateSelector from '@/views/components/DateSelector'

export default {
  name: 'ElectricalEquipmentCheck',
  components: {
    DateSelector,
    FileUploadModule,
    CheckTableBodyItem,
    CheckTableHeader,
    MCheckTable,
    MTitle,
    MForm,
    MGroup,
    SafetyCheckBasicInfo,
    SafetyAccidentBasicData,
    Template,
    ApprovalDocument},
  data () {
    return {
      isPrint: false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: this.boardSlug,
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1
        },
        body: {
          baseInfo: {
            project_name: this.projName,
            com_name: this.comName,
            check_date: '',
            supervisor: '',
            manager: '',
            workTypeTitleList: ['특고(고압)설비', '저압설비'],
            workType: [false, false],
          },
          baseInfo2: {
            수전전압용량: {v: '', kw: ''},
            발전전압용량: {v: '', kw: ''},
            태양광: {v: '', kw: ''},
            계약용량: '',
            점검종별: {value: '', etc: ''},
            점검횟수: '',
          },
          check: {
            checkListA: {
              '특고(고압)설비' : [
                { text: '가공전선로', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '계전기류', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '지중전선로', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '차단기류', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '수배전개폐기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '계측기류', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '배선(모선)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '전력용콘덴서', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '피뢰기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '보호설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '변성기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '부하설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '전력퓨즈', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '접지설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '변압기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '기타설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '수배전반', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '', isAction: false},
              ],

              '저압설비' : [
                { text: '인입구배선', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '용접기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '배·분전반', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '콘덴서', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '배선용차단기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '조명설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '누전차단기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '접지설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '개폐기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '구내전선로', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '배선', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '기타설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '전동기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '발전설비 : 발전기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '전열설비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '발전설비 : 차단장치', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '발전설비 : 축전장치', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '', isAction: false},
              ],

              '피난설비' : [
                { text: '피난기구 : 피난사다리(승강식, 미끄럼봉)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 피난구유도등', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 완강기(간이)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 통로유도등(거실)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 구조대', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 계단통로유도등', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 다수인피난장비', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 객석유도등', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 공기안전매트(APT의 경우)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도표지(공장 다세대)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 비상구위치 및 피난유도등', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상조명등(휴대용비상조명등)', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '인명구조기구 : 방열복, 공기호흡기, 인공소생기', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '기타', isAction: false, data: { '적합': false, '부적합': false, 'N/A': false } },
              ]
            },
            now: '',
            next: '',
            result: [
              { '측정개소': '',
                '상별': {
                  'A-B': { '전압': '', '전류':''},
                  'B-C': { '전압': '', '전류':''},
                  'C-A': { '전압': '', '전류':''},
                  'N-' : { '전압': '', '전류':''},
                },
                '온도': '',
              },
              { '측정개소': '',
                '상별': {
                  'A-B': { '전압': '', '전류':''},
                  'B-C': { '전압': '', '전류':''},
                  'C-A': { '전압': '', '전류':''},
                  'N-' : { '전압': '', '전류':''},
                },
                '온도': '',
              },
              { '측정개소': '',
                '상별': {
                  'A-B': { '전압': '', '전류':''},
                  'B-C': { '전압': '', '전류':''},
                  'C-A': { '전압': '', '전류':''},
                  'N-' : { '전압': '', '전류':''},
                },
                '온도': '',
              },
            ],
          },

        }
      },

      fileList: [],
      test: 'test',
    }
  },
  computed:{
    selectedWorkTypeList () {
      let selected = ''
      let count = 0
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          if (count > 0) {
            selected += ', '
          }
          selected += this.form.body.baseInfo.workTypeTitleList[i]
          count++
        }
      }
      return selected
    },
    점검종별List () {
      return [
        {text:'월', value:'월'},
        {text:'분', value:'분'},
        {text:'반', value:'반'},
        {text:'년', value:'년'},
      ]
    },
    isUpdateMode () {
      return this.$route.params.postId
    },
    boardSlug () {
      return this.$route.params.boardSlug
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    menuA () {
      const menus = []
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          menus.push(this.form.body.baseInfo.workTypeTitleList[i])
        }
      }
      return menus
    },
    menuResults () {
      return ['적합', '부적합', 'N/A']
    },
    comName () {
      if (this.isUpdateMode) {
      } else {
        return this.$store.state.company.companyInfo.com_name;
      }
    },
    projName () {
      return this.$store.state.project.projectInfo.field_name;
    }
  },
  watch: {
    'comName' (value) {
      this.form.body.baseInfo.com_name = value;
    },
    'projName' (value) {
      this.form.body.baseInfo.project_name = value;
    }
  },
  mounted () {
    this.board.slug = this.boardSlug

    if (this.comName) {
      this.form.body.baseInfo.com_name = this.comName
    }
    if (this.projName) {
      this.form.body.baseInfo.project_name = this.projName
    }

    if (this.isUpdateMode) {
      this.loadPost()
    }
  },
  methods: {

    async loadPost () {
      const boardSlug = this.$route.params.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.slug = this.boardSlug
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
    },

    convertFileListToApiFiles () {
      let uploads = '[]'
      const uploadFileIds = []

      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      return uploads
    },

    getOptions (option) {
      const projectId = parseInt(this.$route.params.proj_id)

      const content = JSON.stringify(this.form)
      const uploads = this.convertFileListToApiFiles()

      return {
        projectId,
        content,
        uploads,
        ...option
      }
    },

    async sendUpload (option) {
      if (this.isUpdateMode) {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp:'y', ...this.getOptions(option)})
      } else {
        await this.$store.dispatch('approval/CREATE_POST', {...this.getOptions(option)})
      }
      alert('상신되었습니다.')
      this.onClickClose()
    },
    async sendTemp (option, isCreate) {
      // 임시 저장하기
      if (isCreate || !this.isUpdateMode) {
        await this.$store.dispatch('approval/CREATE_POST', {isTemp: 1, ...this.getOptions(option)})
      } else {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp: 'n', ...this.getOptions(option)})
      }
      alert('임시저장되었습니다.')
      this.onClickClose()
    },

    onChangeInput (value, files) {
      this.form.body = value
      this.fileList = files
    },

    onClickClose () {
      // 닫기
      this.$router.back()
    },
    async onClickDelete () {
      // 삭제
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.onClickClose()
      }
    },
    onClickPrint () {
      // 프린트
      this.isPrint = true
      this.$store.commit('ui/SET_IS_PRINT', true)

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById('print').innerHTML
        const g_oBeforeApproval = document.getElementById('print-approval').innerHTML
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = '#fff'
          document.body.innerHTML = `${g_oBeforeBody}<br>${g_oBeforeApproval}`
        }
        window.print()
        location.reload()
      }, 300)
    },
    async onClickRecall (option) {
      // 결재문서 회수
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        await this.sendTemp(option)
      }
    },
    async onClickTempsave (option) {
      // 임시 저장하기
      await this.sendTemp(option)
    },
    async onClickReTempsave (option) {
      // 재상신
      await this.sendTemp(option, true)
    },
    async onClickUpload (option) {
      // 상신
      await this.sendUpload(option)
    },
    async onClickOk () {
      // 승인
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {postId})
      this.onClickClose()
    },
    async onClickNo (text) {
      // 반려
      const postId = parseInt(this.$route.params.postId)
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', { postId, comment })
      this.onClickClose()
    }
  }
}
</script>

<style scoped>

</style>
